import React from "react";
import { ArrowDownIcon } from "lucide-react";
import { creatorFlow, images, practiceQuestions } from "../../data/content";
import { TransformCta } from "../ui/TransformCta";
const accumulated = ["Maps", "Notes", "Videos", "PDFs", "Charts", "Protocols", "Tips", "Recommendations"];
export function About() {
  return <section className="bg-white px-5 py-16 sm:py-24" aria-labelledby="about-title" data-id="element-38" data-mp="yqmtbq007bsk">
      <div className="mx-auto grid max-w-5xl grid-cols-1 items-start gap-10 lg:grid-cols-[400px_1fr]" data-id="element-39" data-mp="ayxsfl949f00">
        <div className="lg:sticky lg:top-8" data-id="element-40" data-mp="61pclrbfxn1x">
          <div className="overflow-hidden rounded-3xl ring-1 ring-brand-100" data-id="element-41" data-mp="5ytd3yjy2qbd">
            <img src={images.author} alt="Elly Delgado, creator of REFLEXOLOGY 360°" className="aspect-[4/5] w-full object-cover object-top" data-id="element-42" data-mp="jtc8hq1h0tk6" />
          </div>
          <div className="mt-4 rounded-2xl bg-brand-800 px-5 py-4 text-center text-white" data-id="element-43" data-mp="3ngmexhwbps16">
            <p className="font-serif text-xl font-black" data-id="element-44" data-mp="3jg2f26kd8abc">Elly Delgado</p>
            <p className="text-sm text-brand-100" data-id="element-45" data-mp="3jdpy9wqcg5zv">Creator of REFLEXOLOGY 360°™</p>
          </div>
        </div>

        <div data-id="element-46" data-mp="388bhrj4bdp67">
          <p className="text-sm font-bold uppercase tracking-wide text-brand-600" data-id="element-47" data-mp="387te41fbo8o9">About the creator</p>
          <h2 id="about-title" className="mt-2 font-serif text-[2rem] font-black leading-[1.12] text-ink sm:text-5xl" data-id="element-48" data-mp="3cyi9hru4hpso">
            I'm Elly Delgado, and I created <em className="italic text-brand-600" data-id="element-49" data-mp="3i07jd45lzxf6">Reflexology 360°™</em>
          </h2>

          <div className="mt-6 space-y-4 text-lg leading-relaxed text-ink/80" data-id="element-50" data-mp="2kbxjaupdvjqp">
            <p data-id="element-51" data-mp="2pa8pmvggzc46">
              Over time, I learned something that I believe is incredibly important when you're learning a practical skill:
            </p>
            <p className="rounded-2xl bg-brand-50 p-5 font-serif text-2xl font-bold italic leading-snug text-brand-800" data-id="element-52" data-mp="2z7n6gw6b22x0">
              Having information isn't the same as knowing how to use it.
            </p>
            <p data-id="element-53" data-mp="eh5z5h7awzi9">When you're studying reflexology, it's very easy to accumulate:</p>
          </div>

          <ul className="mt-4 flex flex-wrap gap-2" data-id="element-54" data-mp="2akap0serj7q6">
            {accumulated.map(item => <li key={item} className="rounded-full bg-cream px-4 py-2 text-base font-semibold text-ink/80 ring-1 ring-brand-100" data-id="element-55" data-mp="25lpun9m6zi9n">
                {item}
              </li>)}
          </ul>

          <p className="mt-6 text-lg leading-relaxed text-ink/80" data-id="element-56" data-mp="2fj40ygeeiqo8">
            Before you know it, you have information everywhere… but you're still asking:
          </p>
          <ul className="mt-3 space-y-1.5" data-id="element-57" data-mp="1rrotk97rpj64">
            {practiceQuestions.map(q => <li key={q} className="font-serif text-xl font-bold italic text-ink" data-id="element-58" data-mp="1msvguj0b1w70">“{q}”</li>)}
          </ul>

          <div className="mt-6 space-y-4 text-lg leading-relaxed text-ink/80" data-id="element-59" data-mp="1vvo9apl84dyf">
            <p data-id="element-60" data-mp="1vtjx7kd688n2">
              I didn't want to create another ebook that you read once and then forget about. I wanted to create something
              you could actually <strong className="text-ink" data-id="element-61" data-mp="143fahf1xv9io">REFERENCE</strong> — something that organizes the information
              visually and helps you move from:
            </p>
          </div>

          <ol className="mt-5 flex flex-col gap-1.5" data-id="element-62" data-mp="yribbrig13nw">
            {creatorFlow.map((step, i) => <React.Fragment key={step} data-id="element-63" data-mp="k35eytfg1isv" data-mpi={i}>
                <li className="rounded-xl bg-brand-700 px-4 py-3 text-center font-extrabold uppercase tracking-wide text-white" data-id="element-64" data-mp="k46ylmaizdm7">
                  {step}
                </li>
                {i < creatorFlow.length - 1 && <ArrowDownIcon className="mx-auto h-4 w-4 text-brand-500" aria-hidden="true" data-id="element-65" data-mp="1coyij58kd1gp" />}
              </React.Fragment>)}
          </ol>

          <div className="mt-6 space-y-4 text-lg leading-relaxed text-ink/80" data-id="element-66" data-mp="12rtv722zezyb">
            <p data-id="element-67" data-mp="17rf5u9rikwqv">
              So I brought the maps, sequences, protocols, worksheets, and checklists together into one complete system.
            </p>
            <p data-id="element-68" data-mp="3nhrmx6zt5r27">
              My goal is simple: when you open REFLEXOLOGY 360°™, you should know where to look. You shouldn't have to
              search through five different resources, or reopen an entire course just to find one reference.
            </p>
            <p className="font-semibold text-ink" data-id="element-69" data-mp="7sxy5y0n5cj1">You should have a system you can return to.</p>
          </div>
        </div>
      </div>

      <TransformCta label="Yes! I want my Reflexology 360°" data-id="element-70" data-mp="2ue6ri3a38ja" />
    </section>;
}